import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons'
import {
  Alert,
  Box,
  InputAdornment,
  TextField
} from '@mui/material'
import { SPECIAL_PRICE_SCALE_FIELD_SX } from '../../constant/specialPriceViewConstants'
import {
  SPECIAL_PRICE_CREATE_ARIA_LABELS,
  SPECIAL_PRICE_CREATE_FIELD_LABELS,
  SPECIAL_PRICE_CREATE_PLACEHOLDERS,
  SPECIAL_PRICE_CREATE_RANGE_ALERT_SX,
  SPECIAL_PRICE_CREATE_STEP_CONTENT
} from '../specialPriceCreateConstants'

const SpecialPriceEditableScaleList = ({
  fieldErrors,
  onRangeChange,
  onRemoveRange,
  rangeFieldErrors,
  rangeInlineErrorMessage,
  ranges,
  selectedPackage,
  selectedProduct
}) => {
  return (
    <div className="task-form-section">
      <div className="title-promos-form">
        <b>{SPECIAL_PRICE_CREATE_STEP_CONTENT.price.title}</b>
      </div>
      <p>{SPECIAL_PRICE_CREATE_STEP_CONTENT.price.description}</p>
      <hr className="hr-task-form" />

      <div className="special-price-scale-list">
        {ranges.map((range, index) => (
          <Box className="special-price-scale-row" key={`range-${index}`}>
            <div className="special-price-scale-index special-price-scale-index--top">
              <span className="scale-number-circle">{index + 1}</span>
            </div>

            <Box className="special-price-scale-group special-price-scale-group--wide">
              <TextField
                fullWidth
                label={`${SPECIAL_PRICE_CREATE_FIELD_LABELS.minSale}${selectedPackage?.unit ? ` (${selectedPackage.unit})` : ''}`}
                type="number"
                value={range.min_qty}
                InputLabelProps={{ shrink: true }}
                disabled
                variant="outlined"
                sx={SPECIAL_PRICE_SCALE_FIELD_SX}
              />
            </Box>

            <div className="special-price-scale-separator special-price-scale-separator--dash" />

            <Box className="special-price-scale-group special-price-scale-group--wide">
              <TextField
                fullWidth
                label={`${SPECIAL_PRICE_CREATE_FIELD_LABELS.maxSale}${selectedPackage?.unit ? ` (${selectedPackage.unit})` : ''}`}
                type="number"
                InputLabelProps={{ shrink: true }}
                inputProps={{ min: range.min_qty }}
                error={Boolean(selectedProduct && rangeFieldErrors[index]?.max_qty)}
                value={range.max_qty}
                onChange={(event) => onRangeChange(index, 'max_qty', event.target.value)}
                disabled
                placeholder={index === ranges.length - 1 ? SPECIAL_PRICE_CREATE_PLACEHOLDERS.unlimited : ''}
                variant="outlined"
                sx={SPECIAL_PRICE_SCALE_FIELD_SX}
              />
            </Box>

            <div className="special-price-scale-separator">la venta es a</div>

            <Box className="special-price-scale-group special-price-scale-group-price">
              <TextField
                fullWidth
                label={SPECIAL_PRICE_CREATE_FIELD_LABELS.offerPrice}
                placeholder={SPECIAL_PRICE_CREATE_PLACEHOLDERS.price}
                type="number"
                InputLabelProps={{ shrink: true }}
                inputProps={{
                  min: 0,
                  step: 'any',
                  style: { textAlign: 'right' }
                }}
                error={Boolean(selectedProduct && rangeFieldErrors[index]?.special_price)}
                value={range.special_price}
                onChange={(event) => onRangeChange(index, 'special_price', event.target.value)}
                disabled={!selectedProduct}
                variant="outlined"
                sx={SPECIAL_PRICE_SCALE_FIELD_SX}
                InputProps={{
                  startAdornment: <InputAdornment position="start">$</InputAdornment>
                }}
              />
            </Box>

            {ranges.length > 1 && (
              <div className="special-price-scale-actions">
                <button
                  type="button"
                  className="delete-report-btn btn-delete-product special-price-scale-delete-button"
                  onClick={() => onRemoveRange(index)}
                  disabled={!selectedProduct || ranges.length === 1}
                  aria-label={SPECIAL_PRICE_CREATE_ARIA_LABELS.removeScale}
                >
                  <FontAwesomeIcon icon={faTrashAlt} />
                </button>
              </div>
            )}
          </Box>
        ))}
      </div>

      {selectedProduct && (fieldErrors.ranges || rangeInlineErrorMessage) && (
        <Alert severity="error" sx={SPECIAL_PRICE_CREATE_RANGE_ALERT_SX}>
          {fieldErrors.ranges || rangeInlineErrorMessage}
        </Alert>
      )}
    </div>
  )
}

export default SpecialPriceEditableScaleList
